var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkLimiterTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0881 17.8829C12.9395 17.8829 13.6296 17.1927 13.6296 16.3413C13.6296 15.49 12.9395 14.7998 12.0881 14.7998C11.2367 14.7998 10.5466 15.49 10.5466 16.3413C10.5466 17.1927 11.2367 17.8829 12.0881 17.8829ZM12.0881 19.4244C13.7908 19.4244 15.1712 18.0441 15.1712 16.3413C15.1712 14.6386 13.7908 13.2582 12.0881 13.2582C10.3854 13.2582 9.00502 14.6386 9.00502 16.3413C9.00502 18.0441 10.3854 19.4244 12.0881 19.4244Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.62761C21.0233 2.51453 16.8288 0.575562 12.1815 0.575562C7.342 0.575562 2.99358 2.67824 0 6.01987L1.21813 7.11038C3.91235 4.10295 7.82591 2.21056 12.1815 2.21056C16.3641 2.21056 20.1391 3.95564 22.8181 6.75742L24 5.62761Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6363 7.88718C19.2549 5.39671 15.8993 3.84553 12.1815 3.84553C8.30986 3.84553 4.83115 5.52765 2.43629 8.20092L3.65441 9.29143C5.74991 6.95236 8.79377 5.48053 12.1814 5.48053C15.4345 5.48053 18.3706 6.83782 20.4544 9.017L21.6363 7.88718Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2726 10.1467C17.4865 8.27885 14.9699 7.11546 12.1815 7.11546C9.27777 7.11546 6.66874 8.37705 4.87259 10.382L6.09071 11.4725C7.5875 9.80175 9.76167 8.75045 12.1814 8.75045C14.5051 8.75045 16.6023 9.71995 18.0907 11.2765L19.2726 10.1467Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9089 12.4062C15.7182 11.161 14.0404 10.3854 12.1815 10.3854C10.2457 10.3854 8.50633 11.2264 7.3089 12.5631L8.52701 13.6536C9.42508 12.6511 10.7296 12.0204 12.1814 12.0204C13.5756 12.0204 14.834 12.6021 15.727 13.536L16.9089 12.4062Z",
    fill: "#FA1D4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLimiterTitle);
export default __webpack_public_path__ + "static/media/networkLimiterTitle.7ce5da783773addcbf5638bf8651fda0.svg";
export { ForwardRef as ReactComponent };